/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IAny } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';
import FilterScope1Action from './FilterScope1Actions';
import { IFilterScope1State } from './FilterScope1Context';

interface IAction {
  type: string;
  payload?: IAny;
}
const fileUploadReducer = (state: IFilterScope1State, action: IAction) => {
  switch (action.type) {
    case FilterScope1Action.SHOW_MODAL:
      if (action.payload === false) {
        return {
          ...state,
          showModal: action.payload
        };
      }
      return {
        ...state,
        showModal: action.payload
      };
    case FilterScope1Action.SAVE_FILTER_MODAL:
      return {
        ...state,
        saveFilterData: action.payload
      };
    case FilterScope1Action.SAVE_ERROR_MODAL:
      return {
        ...state,
        saveErrorData: action.payload
      };
    case FilterScope1Action.SUBSCRIPTIONDETAILS:
      return {
        ...state,
        subscriptionDetails: action.payload
      };
    default:
      return state;
  }
};

export default fileUploadReducer;
